export const FEATURE_NAME = '@zerops/zerops/feature/service-stack-add-form/modules/service-stack-version-field';
